import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Stack, TextField } from '@mui/material';
import { ContactUsRequestSchema, type ContactUsRequest } from '@vy/api-definition';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { useContactUs } from '../../../../../hooks/requests/use-contact-us';
import { useDialog } from '../../../../../hooks/use-dialog';
import { runMutation } from '../../../../../utils/vy-mutation';

export const ContractUsDialog: React.FC = () => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();
  const contactUsMutation = useContactUs();

  const methods = useForm<ContactUsRequest>({
    resolver: zodResolver(ContactUsRequestSchema),
  });

  const { register } = methods;

  const handleSubmit = methods.handleSubmit(async (data) => {
    await runMutation(contactUsMutation, data, {
      error: 'Failed to send message',
      pending: 'Sending message...',
      success: 'Message sent successfully',
    });
    handleClose();
  });

  return (
    <>
      <Button
        variant="text"
        sx={{
          display: 'inline',
          color: '#1A5BC8',
          fontWeight: 300,
          padding: 0,
          textDecoration: 'underline',
          '&:hover': { backgroundColor: 'transparent' },
        }}
        onClick={handleOpen}
      >
        Contact Us
      </Button>
      <VyDialog
        ctaText="Submit"
        label="Contact Us"
        cancelButtonText="Cancel"
        open={isDialogOpen}
        onSubmit={handleSubmit}
        onClose={handleClose}
        dialogContentProps={{ sx: { overflow: 'hidden' } }}
      >
        <>
          <FormProvider {...methods}>
            <Stack direction="column" sx={{
              gap: 2
            }}>
              <TextField
                {...register('name')}
                size="small"
                error={!!methods.formState.errors.name}
                helperText={methods.formState.errors.name?.message}
                label="Name"
              />

              <TextField
                {...register('email')}
                size="small"
                error={!!methods.formState.errors.email}
                helperText={methods.formState.errors.email?.message}
                label="Email"
              />

              <TextField
                label="Message"
                fullWidth
                multiline
                variant="filled"
                sx={{
                  fontSize: '16px',
                  '& .MuiInputBase-root': {
                    padding: '0px !important',
                    alignItems: 'flex-start',
                    height: '200px',
                  },
                }}
                rows={10}
                {...register('message')}
              />
            </Stack>
          </FormProvider>
        </>
      </VyDialog>
    </>
  );
};
